import { render, staticRenderFns } from "./MyAssociationList.vue?vue&type=template&id=370a60a8&scoped=true&"
import script from "./MyAssociationList.vue?vue&type=script&lang=js&"
export * from "./MyAssociationList.vue?vue&type=script&lang=js&"
import style0 from "./MyAssociationList.vue?vue&type=style&index=0&id=370a60a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a60a8",
  null
  
)

export default component.exports